/*
 * @Autor: lmlss
 * @Date: 2024-08-13 14:34:04
 * @Description:
 * @LastEditors: lmlss
 * @LastEditTime: 2024-08-27 21:47:12
 */
import { IconFont } from "../IconFont";
import { CommonFile } from "marmot_design_ui";
import { FC } from "react";
import "./index.less";
import React from "react";

const contentTypeIconMap = {
  "application/msword": "icon-word",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
    "icon-word",
  "application/vnd.ms-excel": "icon-excel",
  "application/vnd.ms-excel application/x-excel": "icon-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
    "icon-excel",
  "application/pdf": "icon-pdf",
  "application/vnd.ms-powerpoint": "icon-ppt",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation":
    "icon-ppt",
  "audio/mpeg": "icon-mp3",
  "image/png": "icon-a-Group4273188601",
  "image/jpg": "icon-a-Group4273188601",
  "image/jpeg": "icon-a-Group4273188601",
  "video/mp4": "icon-mp4",
  // 'icon-zip'
};

const downLoadFn = (urls: any, fileName: any) => {
  const x = new window.XMLHttpRequest();
  x.open("GET", urls, true);
  x.responseType = "blob";
  x.onload = () => {
    const url = window.URL.createObjectURL(x.response);
    const a = document.createElement("a");
    a.href = url;
    a.target = "_blank";
    a.download = fileName;
    a.style.display = "none";
    document.body.append(a);
    a.click();
  };
  x.send();
};

const formatFileSizeToMB = (sizeInBytes: number): string => {
  if (sizeInBytes === 0) {
    return "0 B";
  }

  const sizeInMB = sizeInBytes / 1024;

  return sizeInMB.toFixed(2) + " KB";
};

interface iProps {
  fileList?: CommonFile[];
  zipFile?: CommonFile;
}

export const ExtendFileCard: FC<iProps> = ({ fileList = [], zipFile }) => {
  if (!fileList?.length) return null;

  return (
    <div className="detail-modal-extend-file-card-list">
      <div className="extend-file">
        <div className="text">附件：</div>
        {!!zipFile?.fileUrl && (
          <div
            className="download-all"
            onClick={() => downLoadFn(zipFile?.fileUrl, zipFile?.name)}
          >
            下载全部
          </div>
        )}
      </div>
      <div className="list">
        {fileList.map((item, index) => (
          <div className="item" key={index}>
            <div className="icon">
              <IconFont
                type={contentTypeIconMap?.[item?.contentType]}
                style={{ fontSize: "40px" }}
              />
            </div>
            <div className="main">
              <div className="title">{item?.name || "-"}</div>
              <div className="size">{formatFileSizeToMB(item?.size)} </div>
            </div>
            <div
              className="download"
              onClick={() => downLoadFn(item?.fileUrl, item?.name)}
            >
              下载
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
